<script setup>

defineProps({
  title: String,
  placement: String,
  backgroundColor: {
    type: String,
    default: 'black'
  },
  infoIconColor: {
     type: String,
     default: 'black'
  }
})
</script>

<template>
  <div class="custom-tooltip">
    <slot name="icon">
      <i class="form-info-icon" :style="{'color': infoIconColor }"></i>
    </slot>
    <div class="tooltip-text" :class="placement" :style="{ 'background-color': backgroundColor }">
      {{ title }}
    </div>
  </div>  
</template>

<style scoped>
.custom-tooltip {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  position: absolute;
  max-width: 300px;
  min-width: 300px;
  height: auto;
  padding: 10px;
  z-index: 10;
  color: white;
  font-weight: normal;
  border-radius: 5px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
}
.custom-tooltip:hover .tooltip-text {
  opacity: 1;
}
.tooltip-text::before {
  content: '';
  position: absolute;
  border-style: solid;
}
.top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-5px);
}
.top::before {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-color: black transparent transparent transparent;
}
.right {
  left: 100%;
  top: 50%;
  transform: translateX(5px) translateY(-50%);
}
.right::before {
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 5px;
  border-color: transparent black transparent transparent;
}

.form-info-icon {
  box-sizing: border-box;
  position: relative;
  transform: scale(var(--ggs,1));
  width: 16px;
  height: 16px;
  border: 2px solid;
  border-radius: 40px;
  display: inline-block;
}

.form-info-icon::after,
.form-info-icon::before {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  border-radius: 3px;
  width: 2px;
  background: currentColor;
  left: 5px
}

.form-info-icon::after {
  bottom: 2px;
  height: 5px
}

.form-info-icon::before {
  height: 2px;
  top: 2px
}
</style>